import axios from "../http/axios/index";
import imageCompression from "browser-image-compression";
import Cookies from "js-cookie";

export const googlemapkeys = () => {
  const dt = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`;

  return dt;
};
export const azureADconfig = () => {
  const dt = {
    _tenantId: "0dd540dc-d233-44ce-9ffc-92b3fb0a60ff",
    _authoritybaseurl: "https://login.microsoftonline.com",
    _resourceBaseUrl: "https://graph.microsoft.com/v1.0", //"https://graph.windows.net";
    _clientid: "13a13b2b-b12b-47d6-9fea-9bf42e5cce6d",
    _clientsecret: "w2t8Q~k4cU5FTEbZuRzQ.~XCvxGBjr2AwRFv3bfk",
    _scopes: ["User.Read"],
  };

  return dt;
};

export const getGlobalMasterLine = async (tableName, callback, findim = false) => {
  let options = [];
  if (localStorage.getItem("allGlobalMasterOption")) {
    const allGlobalMasterOption = JSON.parse(localStorage.getItem("allGlobalMasterOption"));
    const x = allGlobalMasterOption.filter((item) => {
      return item.tablename === tableName;
    });
    if (x.length) {
      options = x[0].values
        .filter((item) => item.status === 1)
        .map((data) => ({
          value: data.code,
          label: data.code + " - " + data.description,
          description: data.description,
          addinfo: data.addinfo ? data.addinfo : "",
          status: data.status ? data.status : 0,
          refid: data.refid ? data.refid : "",
          title: data.code + " - " + data.description,
        }));
    } else {
      if (!findim) {
        const res = await axios.get("api/v1/GlobalMasterlines/findrefid?id=" + tableName);
        const data = res.data.result;
        if (data.length) {
          const arr = {
            tablename: tableName,
            values: data,
          };
          allGlobalMasterOption.push(arr);
          const dataArray = allGlobalMasterOption;
          localStorage.setItem("allGlobalMasterOption", JSON.stringify(dataArray));
          options = data
            .filter((item) => item.status === 1)
            .map((data) => ({
              value: data.code,
              label: data.code + " - " + data.description,
              description: data.description,
              addinfo: data.addinfo ? data.addinfo : "",
              status: data.status ? data.status : 0,
              refid: data.refid ? data.refid : "",
              title: data.code + " - " + data.description,
            }));
        }
      }
    }
  }

  callback(options);
};
export function getControlWorkflow(dataParams, callback) {
  axios
    .get("api/v1/Workflow/getUpdateControlsWF", {
      params: dataParams,
    })
    .then((res) => {
      const workflow = res.data.result;
      const options = {
        status: 200,
        workflow: workflow,
      };
      callback(options);
    })
    .catch((error) => {
      console.error(error);
      let options = {
        status: 500,
      };
      callback(options);
    });
}

export function getGlobalEnumOption(tableName, fieldName, callback) {
  let options = [];
  if (localStorage.getItem("allEnumOption")) {
    const allEnumOption = JSON.parse(localStorage.getItem("allEnumOption"));
    const x = allEnumOption.filter((item) => {
      return item.tablename === tableName && item.columnname === fieldName;
    });
    if (x.length) {
      options = x[0].value.map((data) => ({
        value: data.code,
        label: data.description,
      }));
    }
  }

  callback(options);
}
export function getGlobalWorkerOption(callback) {
  axios
    .get("api/v1/LookupData/getActiveWorkersLookup")
    .then((res) => {
      const data = res.data.result;
      const workerOption = data.map((item) => ({
        value: item.recid,
        label: item.personnelNumber + " - " + item.fullname,
        fullname: item.fullname,
        personnelNumber: item.personnelNumber,
        person: item.person,
        workerdatahistoryrecid: item.workerdatahistoryrecid,
        ...item,
      }));

      callback(workerOption);
    })
    .catch((error) => {
      console.error(error);
      callback([]);
    });
}

export function getFindimbySubcompanyOption(subcompany, listFindim) {
  axios
    .get("api/v1/GlobalMasterlines/getfindimbysubcompanycode", {
      params: {
        companycode: subcompany,
      },
    })
    .then((res) => {
      const data = res.data.result;
      // var output = []
      listFindim.map((item) => {
        const list = data.filter((dt) => dt.tablename === item.value);
        // console.log('list', list);
        if (list.length) {
          const listdata = {
            tablename: list[0].tablename,
            values: list,
          };
          // output.push(listdata)
          checkGlobalMaster(list[0].tablename, listdata);
        } else {
          const listdata = {
            tablename: item.value,
            values: [],
          };
          checkGlobalMaster(item.value, listdata);
        }
      });
    })
    .catch((error) => {
      console.error(error);
    });
}

export function checkGlobalMaster(tablename, listdata) {
  const allGlobalMasterOption = JSON.parse(localStorage.getItem("allGlobalMasterOption"));
  const x = allGlobalMasterOption.filter((item) => {
    return item.tablename === tablename;
  });
  if (!x.length) {
    // console.log('listdata', listdata);
    allGlobalMasterOption.push(listdata);
    const dataArray = allGlobalMasterOption;
    // console.log(dataArray);
    localStorage.setItem("allGlobalMasterOption", JSON.stringify(dataArray));
  } else {
    let dataArray = allGlobalMasterOption;
    var index = dataArray.findIndex((obj) => obj.tablename === tablename);
    // console.log(index);
    dataArray[index].tablename = tablename;
    dataArray[index].values = listdata.values;
    // console.log(dataArray);
    localStorage.setItem("allGlobalMasterOption", JSON.stringify(dataArray));
  }
}

export function getSystemObjectAction(id) {
  const objectSystem = JSON.parse(localStorage.getItem("objectSystem"));

  if (!objectSystem) {
    alert("Permission not found, please login again");
    window.location.href = "/login";

    const themeColor = JSON.parse(JSON.stringify(localStorage.getItem("themeColor")));
    const listFavoriteStorage = JSON.parse(localStorage.getItem("listFavoriteStorage"));

    localStorage.clear();

    if (themeColor) localStorage.setItem("themeColor", themeColor);
    if (listFavoriteStorage)
      localStorage.setItem("listFavoriteStorage", JSON.stringify(listFavoriteStorage));

    Object.keys(Cookies.get()).forEach((cookie) => {
      Cookies.remove(cookie);
    });

    return;
  }

  const x = objectSystem.filter((item) => {
    return item.systemObjectID === id;
  });

  var add = "0",
    update = "0",
    del = "0",
    viewboxanalysis = "0",
    viewlistworker = "0",
    viewfinalscore = "0",
    viewcapacity = "0",
    viewcurve = "0",
    viewfinalcalibration = "0",
    viewworker = "0",
    viewAction = "0",
    bulkAction = "0",
    precalc = "0",
    process = "0",
    Confirm = "0",
    list_employee = "0",
    cancel = "0",
    companyNews = "0",
    companyPolicy = "0",
    employeeEnd = "0",
    ProbationDate = "0",
    Birthday = "0",
    Pension = "0",
    OnLeave = "0",
    employee = "0",
    graphic = "0",
    reportasready = "0",
    ExportPositionDescription = "0",
    ExportJobProfile = "0",
    JobEvaluationSummary = "0",
    ReassignWF = "0",
    isAdmin = "0",
    Recruitment = "0",
    ClockInOut = "0",
    Tasklist = "0",
    GenerateMassEventsPerformance = "0",
    viewActionBulkPerformance = "0",
    GenerateMassEventsPotential = "0",
    viewActionBulkPotential = "0",
    MoveBacktoPlan = "0",
    CancelPerformance = "0",
    ClosePlanningStage = "0",
    CloseMonitoringStage = "0",
    Confirmation = "0",
    download = "0",
    downloadExcel = "0",
    updateWorkerCompetency = "0",
    Approval = "0",
    uploadFinalRating = "0",
    DownloadLedgerByWorker = "0",
    EnableEdit = "0",
    collaboration = "0",
    generateidcard = "0",
    generatepayslip = "0",
    dataChanges = "0",
    confirmedLoan = "0",
    postponedLoan = "0",
    disableEditProfilePicture = "0",
    WorkerLevel = "0";

  if (x.length) {
    if (x[0].types === "Menu") {
      if (x[0].access === "0") {
        window.location.replace("/403");
        return null;
      }
    }

    add = x[0].children ? x[0].children.find((dt) => dt.name === "Add") : null;
    isAdmin = x[0].children ? x[0].children.find((dt) => dt.name === "isAdmin") : null;
    update = x[0].children ? x[0].children.find((dt) => dt.name === "Update") : null;
    del = x[0].children ? x[0].children.find((dt) => dt.name === "Delete") : null;
    precalc = x[0].children ? x[0].children.find((dt) => dt.name === "Pre Calc") : null;
    process = x[0].children ? x[0].children.find((dt) => dt.name === "Process") : null;
    Confirm = x[0].children ? x[0].children.find((dt) => dt.name === "Confirm") : null;
    list_employee = x[0].children ? x[0].children.find((dt) => dt.name === "List Employee") : null;
    reportasready = x[0].children
      ? x[0].children.find((dt) => dt.name === "Report as Ready")
      : null;
    cancel = x[0].children ? x[0].children.find((dt) => dt.name === "Cancel") : null;
    companyNews = x[0].children ? x[0].children.find((dt) => dt.name === "Company News") : null;
    companyPolicy = x[0].children ? x[0].children.find((dt) => dt.name === "Company Policy") : null;
    employeeEnd = x[0].children
      ? x[0].children.find((dt) => dt.name === "Employee End Date")
      : null;
    ProbationDate = x[0].children ? x[0].children.find((dt) => dt.name === "Probation") : null;
    Birthday = x[0].children ? x[0].children.find((dt) => dt.name === "Birthday") : null;
    Pension = x[0].children ? x[0].children.find((dt) => dt.name === "Pension") : null;
    WorkerLevel = x[0].children ? x[0].children.find((dt) => dt.name === "Worker Level") : null;
    OnLeave = x[0].children ? x[0].children.find((dt) => dt.name === "On Leave") : null;
    employee = x[0].children ? x[0].children.find((dt) => dt.name === "Employee") : null;
    graphic = x[0].children ? x[0].children.find((dt) => dt.name === "Graphic") : null;
    ClockInOut = x[0].children ? x[0].children.find((dt) => dt.name === "ClockInOut") : null;
    Recruitment = x[0].children ? x[0].children.find((dt) => dt.name === "Recruitment") : null;
    ExportPositionDescription = x[0].children
      ? x[0].children.find((dt) => dt.name === "Export Position Description")
      : null;
    ExportJobProfile = x[0].children
      ? x[0].children.find((dt) => dt.name === "Export Job Profile")
      : null;
    JobEvaluationSummary = x[0].children
      ? x[0].children.find((dt) => dt.name === "Job Evaluation Summary")
      : null;
    ReassignWF = objectSystem?.find((dt) => dt.name === "ReassignWF")?.access;
    Tasklist = x[0].children ? x[0].children.find((dt) => dt.name === "Tasklist") : null;
    viewboxanalysis = x[0].children
      ? x[0].children.find((dt) => dt.name === "viewboxanalysis")
      : null;
    viewlistworker = x[0].children
      ? x[0].children.find((dt) => dt.name === "viewlistworker")
      : null;
    viewfinalscore = x[0].children
      ? x[0].children.find((dt) => dt.name === "viewfinalscore")
      : null;
    viewcapacity = x[0].children ? x[0].children.find((dt) => dt.name === "viewcapacity") : null;
    viewcurve = x[0].children ? x[0].children.find((dt) => dt.name === "viewcurve") : null;
    viewfinalcalibration = x[0].children
      ? x[0].children.find((dt) => dt.name === "viewfinalcalibration")
      : null;
    viewworker = x[0].children ? x[0].children.find((dt) => dt.name === "viewworker") : null;
    viewAction = x[0].children ? x[0].children.find((dt) => dt.name === "viewAction") : null;
    bulkAction = x[0].children ? x[0].children.find((dt) => dt.name === "Bulk Action") : null;
    GenerateMassEventsPerformance = x[0].children
      ? x[0].children.find((dt) => dt.name === "GenerateMassEventsPerformance")
      : null;
    viewActionBulkPerformance = x[0].children
      ? x[0].children.find((dt) => dt.name === "viewActionBulkPerformance")
      : null;
    GenerateMassEventsPotential = x[0].children
      ? x[0].children.find((dt) => dt.name === "GenerateMassEventsPotential")
      : null;
    viewActionBulkPotential = x[0].children
      ? x[0].children.find((dt) => dt.name === "viewActionBulkPotential")
      : null;
    MoveBacktoPlan = x[0].children
      ? x[0].children.find((dt) => dt.name === "MoveBacktoPlan")
      : null;
    CancelPerformance = x[0].children
      ? x[0].children.find((dt) => dt.name === "CancelPerformance")
      : null;
    ClosePlanningStage = x[0].children
      ? x[0].children.find((dt) => dt.name === "ClosePlanningStage")
      : null;
    CloseMonitoringStage = x[0].children
      ? x[0].children.find((dt) => dt.name === "CloseMonitoringStage")
      : null;
    Confirmation = x[0].children ? x[0].children.find((dt) => dt.name === "Confirmation") : null;
    download = x[0].children ? x[0].children.find((dt) => dt.name === "Download") : null;
    downloadExcel = x[0].children ? x[0].children.find((dt) => dt.name === "DownloadExcel") : null;
    updateWorkerCompetency = x[0].children
      ? x[0].children.find((dt) => dt.name === "updateWorkerCompetency")
      : null;
    Approval = x[0].children ? x[0].children.find((dt) => dt.name === "Approval") : null;
    uploadFinalRating = x[0].children
      ? x[0].children.find((dt) => dt.name === "uploadFinalRating")
      : null;
    DownloadLedgerByWorker = x[0].children
      ? x[0].children.find((dt) => dt.name === "DownloadLedgerByWorker")
      : null;
    EnableEdit = x[0].children ? x[0].children.find((dt) => dt.name === "EnableEdit") : null;
    collaboration = x.length ? x.find((dt) => dt.name === "collaboration") : null;
    generateidcard = x[0].children
      ? x[0].children.find((dt) => dt.name === "generateidcard")
      : null;
    generatepayslip = x[0].children
      ? x[0].children.find((dt) => dt.name === "generatePayslip")
      : null;
    dataChanges = x[0].children ? x[0].children.find((dt) => dt.name === "Data Changes") : null;
    confirmedLoan = x[0].children ? x[0].children.find((dt) => dt.name === "Confirmed Loan") : null;
    postponedLoan = x[0].children ? x[0].children.find((dt) => dt.name === "Postponed Loan") : null;
    disableEditProfilePicture = x[0].children
      ? x[0].children.find((dt) => dt.name === "Edit Profile Picture")
      : null;
  }

  const actionObject = {
    ReassignWF: ReassignWF ? (ReassignWF === "1" ? true : false) : false,
    add: add ? (add.access === "1" ? true : false) : false,
    isAdmin: isAdmin ? (isAdmin.access === "1" ? true : false) : false,
    update: update ? (update.access === "1" ? true : false) : false,
    delete: del ? (del.access === "1" ? true : false) : false,
    precalc: precalc ? (precalc.access === "1" ? true : false) : false,
    process: process ? (process.access === "1" ? true : false) : false,
    Confirm: Confirm ? (Confirm.access === "1" ? true : false) : false,
    list_employee: list_employee ? (list_employee.access === "1" ? true : false) : false,
    reportasready: reportasready ? (reportasready.access === "1" ? true : false) : false,
    cancel: cancel ? (cancel.access === "1" ? true : false) : false,
    companyNews: companyNews ? (companyNews.access === "1" ? true : false) : false,
    companyPolicy: companyPolicy ? (companyPolicy.access === "1" ? true : false) : false,
    employeeEnd: employeeEnd ? (employeeEnd.access === "1" ? true : false) : false,
    ProbationDate: ProbationDate ? (ProbationDate.access === "1" ? true : false) : false,
    Birthday: Birthday ? (Birthday.access === "1" ? true : false) : false,
    Pension: Pension ? (Pension.access === "1" ? true : false) : false,
    OnLeave: OnLeave ? (OnLeave.access === "1" ? true : false) : false,
    employee: employee ? (employee.access === "1" ? true : false) : false,
    graphic: graphic ? (graphic.access === "1" ? true : false) : false,
    ClockInOut: ClockInOut ? (ClockInOut.access === "1" ? true : false) : false,
    Recruitment: Recruitment ? (Recruitment.access === "1" ? true : false) : false,
    ExportPositionDescription: ExportPositionDescription
      ? ExportPositionDescription.access === "1"
        ? true
        : false
      : false,
    ExportJobProfile: ExportJobProfile ? (ExportJobProfile.access === "1" ? true : false) : false,
    JobEvaluationSummary: JobEvaluationSummary
      ? JobEvaluationSummary.access === "1"
        ? true
        : false
      : false,
    Tasklist: Tasklist ? (Tasklist.access === "1" ? true : false) : false,
    viewboxanalysis: viewboxanalysis ? (viewboxanalysis.access === "1" ? true : false) : false,
    viewlistworker: viewlistworker ? (viewlistworker.access === "1" ? true : false) : false,
    viewfinalscore: viewfinalscore ? (viewfinalscore.access === "1" ? true : false) : false,
    viewcapacity: viewcapacity ? (viewcapacity.access === "1" ? true : false) : false,
    viewcurve: viewcurve ? (viewcurve.access === "1" ? true : false) : false,
    viewfinalcalibration: viewfinalcalibration
      ? viewfinalcalibration.access === "1"
        ? true
        : false
      : false,
    viewworker: viewworker ? (viewworker.access === "1" ? true : false) : false,
    // viewAction: true,
    viewAction: viewAction ? (viewAction.access === "1" ? true : false) : false,
    bulkAction: bulkAction ? (bulkAction.access === "1" ? true : false) : false,
    GenerateMassEventsPerformance: GenerateMassEventsPerformance
      ? GenerateMassEventsPerformance.access === "1"
        ? true
        : false
      : false,
    viewActionBulkPerformance: viewActionBulkPerformance
      ? viewActionBulkPerformance.access === "1"
        ? true
        : false
      : false,
    GenerateMassEventsPotential: GenerateMassEventsPotential
      ? GenerateMassEventsPotential.access === "1"
        ? true
        : false
      : false,
    viewActionBulkPotential: viewActionBulkPotential
      ? viewActionBulkPotential.access === "1"
        ? true
        : false
      : false,
    MoveBacktoPlan: MoveBacktoPlan ? (MoveBacktoPlan.access === "1" ? true : false) : false,
    CancelPerformance: CancelPerformance
      ? CancelPerformance.access === "1"
        ? true
        : false
      : false,
    ClosePlanningStage: ClosePlanningStage
      ? ClosePlanningStage.access === "1"
        ? true
        : false
      : false,
    CloseMonitoringStage: CloseMonitoringStage
      ? CloseMonitoringStage.access === "1"
        ? true
        : false
      : false,
    Confirmation: Confirmation ? (Confirmation.access === "1" ? true : false) : false,
    download: download ? (download.access === "1" ? true : false) : false,
    downloadExcel: downloadExcel ? (downloadExcel.access === "1" ? true : false) : false,
    updateWorkerCompetency: updateWorkerCompetency
      ? updateWorkerCompetency.access === "1"
        ? true
        : false
      : false,
    Approval: Approval ? (Approval.access === "1" ? true : false) : false,
    uploadFinalRating: uploadFinalRating
      ? uploadFinalRating.access === "1"
        ? true
        : false
      : false,
    DownloadLedgerByWorker: DownloadLedgerByWorker
      ? DownloadLedgerByWorker.access === "1"
        ? true
        : false
      : false,
    EnableEdit: EnableEdit ? (EnableEdit.access === "1" ? true : false) : false,
    collaboration: collaboration ? (collaboration.access === "1" ? true : false) : false,
    generateidcard: generateidcard ? (generateidcard.access === "1" ? true : false) : false,
    generatepayslip: generatepayslip ? (generatepayslip.access === "1" ? true : false) : false,
    dataChanges: dataChanges ? (dataChanges.access === "1" ? true : false) : false,
    confirmedLoan: confirmedLoan ? (confirmedLoan.access === "1" ? true : false) : false,
    postponedLoan: postponedLoan ? (postponedLoan.access === "1" ? true : false) : false,
    disableEditProfilePicture: disableEditProfilePicture
      ? disableEditProfilePicture.access === "1"
        ? true
        : false
      : false,
    WorkerLevel: WorkerLevel ? (WorkerLevel.access === "1" ? true : false) : false,
  };

  // if (id === "collaboration") {
  //   var addCollaboration = (collaboration = "0");
  // }
  return actionObject;
}

export function getSystemObjectActionArray(id) {
  const objectSystem = JSON.parse(localStorage.getItem("objectSystem"));

  const x = objectSystem.filter((item) => {
    return item.systemObjectID === id;
  });
  var listActive = [];
  if (x.length) {
    listActive = x[0].children.filter((item) => {
      return item.access === "1" && item.types === "Page Detail";
    });
  }

  return listActive;
}
export function getSystemObjectActionArrayForReport(id) {
  const objectSystem = JSON.parse(localStorage.getItem("objectSystem"));
  var listActive = [];
  var array = [];
  if (id !== null) {
    const x = objectSystem.filter((item) => {
      return item.systemObjectID === id && parseInt(item.access) === 1;
    });

    if (x.length) {
      listActive = x[0].children.filter((item) => {
        return (
          item.types === "Page Detail" &&
          item.access === "1" &&
          item.children.filter((item) => {
            return item.types === "Page Detail Report" && item.access === "1";
          })
        );
      });
      listActive.map((list) => {
        var y = {
          ...list,
          children: list.children.filter((item) => {
            return item.types === "Page Detail Report" && item.access === "1";
          }),
        };
        array.push(y);
      });
    }
  }
  return array;
}
export function getSystemObjectActionProcessArrayForSearch() {
  const objectSystem = JSON.parse(localStorage.getItem("objectSystem"));
  const x = objectSystem.filter((item) => {
    return item.icon === "forReport" && item.types === "Page Detail";
  });
  var listActive = [];
  if (x.length) {
    x.map((list) => {
      if (list.children.length) {
        list.children.map((item) => {
          var y = {
            ...item,
          };
          listActive.push(y);
        });
      }
    });
  }
  return listActive;
}

export function getSystemObjectActionProcessArray(id) {
  const objectSystem = JSON.parse(localStorage.getItem("objectSystem"));

  const x = objectSystem.filter((item) => {
    return item.systemObjectID === id;
  });
  var listActive = [];
  if (x.length) {
    listActive = x[0].children.filter((item) => {
      return item.access === "1" && item.types === "Action-Process";
    });
  }

  return listActive;
}

export function redirectToLogin(urlTujuan) {
  window.location.href = urlTujuan;
}

export function getGlobalPreload(url, params, callback) {
  axios
    .get(url, {
      params: params,
    })
    .then((res) => {
      const data = res.data.result;
      callback(data);
    })
    .catch((error) => {
      console.error(error);
      callback([]);
    });

  // let options = [];
  // if (localStorage.getItem("allEnumOption")) {
  //   const allEnumOption = JSON.parse(localStorage.getItem("allEnumOption"));
  //   const x = allEnumOption.filter((item) => {
  //     return item.tablename === tableName && item.columnname === fieldName;
  //   });
  //   if (x[0]) {
  //     options = x[0].value.map((data) => ({
  //       value: data.code,
  //       label: data.description,
  //     }));
  //   }
  // }

  // callback(options);
}
export function getLookupActiveWorkers() {
  return [];
}

export function getDescCompany(code) {
  // console.log(localStorage.getItem("companyList"));
  if (localStorage.getItem("companyList")) {
    const companyList = JSON.parse(localStorage.getItem("companyList"));
    // console.log(companyList);
    var cekdata = companyList.filter((item) => item.value === code);
    if (cekdata.length) {
      return cekdata[0].companyName;
    } else {
      return code;
    }
  } else {
    return code;
  }
}
export function getDescSubcompany(code) {
  // console.log(localStorage.getItem("subcompanyList"));
  if (localStorage.getItem("subcompanyList")) {
    const subcompanyList = JSON.parse(localStorage.getItem("subcompanyList"));
    // console.log(subcompanyList);
    var cekdata = subcompanyList.filter((item) => item.value === code);
    if (cekdata.length) {
      return cekdata[0].name;
    } else {
      return code;
    }
  } else {
    return code;
  }
}

export function withBackgroundLocation(location, uri) {
  // valid uri for modal gallery
  const validUri = ["/app/kankei/SM301/generate-day-payment-balance"];

  if (validUri.includes(uri)) {
    return location;
  }

  return null;
}

export function handleImageCompressThenUpload(imageFile, uploadToServer) {
  console.error(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
  };

  imageCompression(imageFile, options)
    .then(function (compressedFile) {
      console.error(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

      return uploadToServer(compressedFile);
    })
    .catch(function (error) {
      console.error(error.message);
    });
}

export function getSingleOptionValue(options) {
  return options.length === 1 ? options[0].value : "";
}

export function multiSearchFilter(data, value, properties) {
  const searchTerms = value
    .trim()
    .split(/\s*,\s*| {2,}| (?=\d)|(?<=\d) /)
    .map((term) => term.toLowerCase())
    .filter((term) => term.length);

  return data.filter((item) =>
    searchTerms.some((term) =>
      properties.some((prop) => String(item[prop]).toLowerCase().includes(term))
    )
  );
}
